import { SearchResultModel } from "./searchResultModel"

export class MarketSearchResultModel extends SearchResultModel {
  getName(locale) {
    if (!this.document || !this.document.name || !this.document.name[locale]) {
      return ""
    }
    return this.document.name[locale]
  }

  getText(locale) {
    if (!this.document || !this.document.description || !this.document.description[locale]) {
      return ""
    }
    return this.document.description[locale]
  }

  getLinkUrl() {
    return "/markets/" + this.document.url || "#"
  }
}
